import { stripMarkdownToText } from "~/lib/stripMarkdownToText";

// Private-use characters, so markdown parsing neither reads nor escapes them.
const OPEN = "";
const CLOSE = "";

/**
 * Flatten a search snippet's markdown to plain text, keeping its `<em>` match
 * markers. A snippet that was only a table comes back empty.
 */
export function plainSnippet(snippet: string): string {
  const marked = snippet.replaceAll("<em>", OPEN).replaceAll("</em>", CLOSE);
  return stripMarkdownToText(marked).replaceAll(OPEN, "<em>").replaceAll(CLOSE, "</em>");
}

const MIN_TERM_LENGTH = 2;

/**
 * Wrap the query's words in `text` with `<em>`, as a snippet would. A term
 * matches at the start of a word, and longer terms win where terms overlap.
 */
export function markTerms(text: string, query: string): string {
  const terms = query
    .split(/\s+/)
    .filter((term) => term.length >= MIN_TERM_LENGTH)
    .sort((a, b) => b.length - a.length)
    .map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  return terms.length > 0
    ? text.replace(new RegExp(`\\b(?:${terms.join("|")})`, "gi"), "<em>$&</em>")
    : text;
}
